module.exports = __webpack_public_path__ + "static/media/white_logo.4d2fc57f.png";